import { api } from './api.js';
import { TeknavData } from '../../teknav-data.js';

function toQuery(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') query.set(key, String(value));
  });
  const s = query.toString();
  return s ? `?${s}` : '';
}

const articleCache = new Map();

export const contentApi = {
  async listArticles(params = {}) {
    const res = await api.get(`/api/articles${toQuery(params)}`);
    return res;
  },

  async getArticle(slug) {
    if (articleCache.has(slug)) {
      return articleCache.get(slug);
    }
    const res = await api.get(`/api/articles/${encodeURIComponent(slug)}`);
    articleCache.set(slug, res);
    return res;
  },

  async getRelated(slug) {
    return api.get(`/api/articles/${encodeURIComponent(slug)}/related`);
  },

  async listSeries() {
    const res = await api.get('/api/series');
    return res?.items ?? [];
  },

  async getSeries(slug) {
    const res = await api.get(`/api/series/${encodeURIComponent(slug)}`);
    return res?.series;
  },

  async listNewsletterArchive() {
    const res = await api.get('/api/newsletter/archive');
    return res?.items ?? [];
  },

  async getNewsletterIssue(slug) {
    const res = await api.get(`/api/newsletter/archive/${encodeURIComponent(slug)}`);
    return res?.campaign;
  },

  async search(params = {}) {
    return api.get(`/api/search${toQuery(params)}`);
  },

  async listCategories() {
    const res = await api.get('/api/categories');
    return res?.items ?? [];
  },

  async getCategory(slug) {
    const res = await api.get(`/api/categories/${encodeURIComponent(slug)}`);
    return res?.category;
  },

  async listAuthors() {
    const res = await api.get('/api/authors');
    return res?.items ?? [];
  },

  async getAuthor(slug) {
    const res = await api.get(`/api/authors/${encodeURIComponent(slug)}`);
    return res?.author;
  },

  async listJobs() {
    const res = await api.get('/api/jobs');
    return res?.items ?? [];
  },

  submitJob(payload) {
    return api.post('/api/jobs', payload);
  },

  async listCourses() {
    const res = await api.get('/api/courses');
    return res?.items ?? [];
  },

  subscribeNewsletter(email, captchaId, userSolution) {
    return api.post('/api/newsletter', { email, captchaId, userSolution });
  },

  trackEvent(payload) {
    return api.post('/api/analytics/events', payload);
  },

  toggleReaction(articleId, type) {
    return api.post(`/api/articles/${encodeURIComponent(articleId)}/reactions`, { type });
  },

  toggleSaved(articleId) {
    return api.post(`/api/articles/${encodeURIComponent(articleId)}/save`, {});
  },

  fallbackArticles() {
    return TeknavData.articles ?? [];
  },

  fallbackAuthors() {
    return TeknavData.authors ?? [];
  },
};
